export const onCopyFailedNotificationText = "DsqsHd";
export const onMoveFailedNotificationText = "FPmVm";
export default {onCopyFailedNotificationText,onMoveFailedNotificationText};